import React, { forwardRef, useContext } from 'react'
import PluginContext from './PluginContext'

// if user not enabled router plugin, then return directly
const getToArgFromProp = props => props.to || props.link || props.url || props.route

const getHrefFromToProp = props => {
  if (props.href) {
    return props.href
  }

  const toArg = getToArgFromProp(props)
  if (toArg && toArg.pathname) {
    return toArg.pathname
  }

  if (typeof toArg === 'string') {
    return toArg
  }
}

/* ---------------------------------- */

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

const handleLinkClick = (ev, props, navigate) => {
  if (props.onClick) props.onClick(ev)

  if (
    !ev.defaultPrevented && // onClick prevented default
    ev.button === 0 && // ignore everything but left clicks
    (!props.target || props.target === "_self") && // let browser handle "target=_blank" etc.
    !isModifiedEvent(ev) // ignore clicks with modifier keys
  ) {

    if (navigate) {
      ev.preventDefault()
      navigate()
    }
  }
}

const hasLinkProps = props => props.href || props.to || props.link || props.url

const getLinkProp = (routerPlugin, props) => {
  if (props.href) {
    return {
      href: props.href,
      navigate: false
    }
  }

  if (!routerPlugin) {
    const alternativeHref = getHrefFromToProp(props)
    return {
      href: alternativeHref,
      navigate: false
    }
  }
  const toArg = props.to || props.link || props.url

  return {
    href: routerPlugin.getFinalPath(toArg),
    navigate: () => routerPlugin.navigate(toArg, {
      replace: props.replace,
      mode: props.mode
    })
  }
}

/* ---------------------------------- */

const withLink = Component => {
  const displayName = `withLink(${Component.displayName || Component.name})`
  const WrappedComponent = forwardRef((props, ref) => {
    const plugins = useContext(PluginContext)
    const {
      href,
      navigate
    } = getLinkProp(plugins.$router, props)
    const handleClick = ev => handleLinkClick(ev, props, navigate)

    return (
      <Component {...props} ref={ref} href={href} onClick={handleClick}></Component>
    )
  })

  WrappedComponent.displayName = displayName
  WrappedComponent.hasLinkProps = hasLinkProps

  return WrappedComponent
}

const Link = withLink(({ title, href, onClick, target, children }) => {
  const linkProps = { title, href, onClick, target }
  return (
    <a {...linkProps}>{children}</a>
  )
})

Link.hasLinkProps = hasLinkProps

export default Link
export {
  withLink
}